import { getParameterFromURL } from './getParameterFromUrl';
import saveABTestValue from './saveABTestValue';

/** `ab_name` of the test — also the localStorage key `saveABTestValue` stores the group under. */
const AB_TEST_KEY = 'p29v74_PDF_highPrices29_39';

export type PDFHighPricesGroup = 'A' | 'B';

let groupCache: PDFHighPricesGroup | null = null;

/**
 * The test runs on the v74p29 link only: onboarding appends
 * `?p29v74PDFHighPrices2939=true` when the `p29v74_PDF_highPrices29_39` Firebase
 * flag is on. Without the param the test is inactive and nothing changes.
 */
const isTestActive = (): boolean => getParameterFromURL('p29v74PDFHighPrices2939') === 'true';

const readStoredGroup = (): PDFHighPricesGroup | null => {
  const stored = localStorage.getItem(AB_TEST_KEY);

  return stored === 'A' || stored === 'B' ? stored : null;
};

/**
 * Assigns the 50/50 group and fires the `AB_TEST` event. The distribution point is
 * `show_payment_page` on the main paywall, so this is called from there and nowhere else.
 *
 * `saveABTestValue` persists the group in localStorage, so a reload keeps the same
 * group and doesn't track the event twice.
 */
export const assignPDFHighPricesGroup = (): void => {
  if (!isTestActive() || groupCache !== null) {
    return;
  }

  groupCache = saveABTestValue(2, AB_TEST_KEY, 'A', 'B', 50, 50) === `${AB_TEST_KEY}_B` ? 'B' : 'A';
};

/**
 * The group assigned at the paywall, or `null` when the test is inactive or the
 * distribution point hasn't been reached yet. Never assigns a group itself.
 */
export const getPDFHighPricesGroup = (): PDFHighPricesGroup | null => {
  if (!isTestActive()) {
    return null;
  }

  if (groupCache === null) {
    groupCache = readStoredGroup();
  }

  return groupCache;
};

/** `true` for the test group, which gets the PDF upsell at 39.99 instead of 29.99. */
export const isPDFHighPricesGroupB = (): boolean => getPDFHighPricesGroup() === 'B';
